import { Card, CardContent, Grid, Stack } from '@mui/material'
import { ListContent, Section } from '@wolfdanepug/common-react'
import { useContext, useEffect, useMemo } from 'react'
import { useQuery } from '../../../lib/useQuery'
import SettingCard from '../../../components/settings/SettingCard'
import { PageContext } from '../../../context/page'

export default function Settings() {
	const { setPage } = useContext(PageContext)
	const { data, loading } = useQuery(ListContent, {
		filter: {
			name: 'AccountSettings'
		}
	})

	useEffect(() => {
		setPage({
			title: 'Settings',
			description: 'Manage Your Settings'
		})
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const settings = useMemo(() => {
		if (!data) {
			return []
		}

		const items = data?.items
		const reduced = items.reverse().reduce((acc: any, setting: any) => {
			if (!acc[setting.category]) {
				acc[setting.category] = []
			}
			acc[setting.category].push(setting)
			return acc
		}, {})

		const output: any = []
		for (const key in reduced) {
			output.push(reduced[key])
		}

		return output
	}, [data])

	if (loading) {
		return null
	}

	return (
		<>
			<Section>
				<Stack gap={6}>
					{settings?.map((group: any, index: number) => (
						<Card key={`settings-group-${index}`}>
							<CardContent>
								<Grid container spacing={5}>
									{group.map((setting: any) => (
										<Grid item xs={12} md={4} key={`setting-${setting.id}`}>
											<SettingCard {...setting} />
										</Grid>
									))}
								</Grid>
							</CardContent>
						</Card>
					))}
				</Stack>
			</Section>
		</>
	)
}
